import { formatMoney } from 'src/utils/formatMoney';
import { isSiteCanadian } from 'src/utils/helpers';
import { useLocalization } from 'src/utils/useLocalization';
import './style.scss';

export interface IResumeContents {
    content: any;
    date: string;
}
export const Resume: React.FC<IResumeContents> = ({ content, date }) => {
    const { reserves } = useLocalization();
    return (
        <>
            <div className='monthly-totals'>
                <div className='list-column'>
                    <p className='table-title-strong'>
                        {reserves.MONTHLY_TOTALS_HEADER}
                        {` ${reserves.MONTHLY_FOR} `}
                        {date}
                    </p>
                    <div className='table-list'>
                        <div className='table-list-row table-list-header'>
                            <div className='table-list-label'>
                                <span>
                                    {reserves.MONTHLY_TOTALS_DESCRIPTION}
                                </span>
                            </div>
                            <div className='table-list-value'>
                                <span>{reserves.MONTHLY_TOTALS_CREDITS}</span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>
                                    {reserves.MONTHLY_TOTALS_STARTBALANCE}
                                </span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.monthlyTotals
                                            .ReserveStartingBalance,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>{reserves.MONTHLY_TOTALS_EARNINGS}</span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.monthlyTotals
                                            .DealerUpFrontEarningsAmount,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>
                                    {reserves.MONTHLY_TOTALS_ENDBALANCE}
                                </span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.monthlyTotals
                                            .ReserveEndingBalance,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>
                                    {reserves.MONTHLY_TOTALS_BACKAMOUNT}
                                </span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.monthlyTotals
                                            .NetReserveChargeBackAmount,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>
                                    {isSiteCanadian()
                                        ? reserves.MONTHLY_TOTALS_ADJUSTMENT_CA
                                        : reserves.MONTHLY_TOTALS_ADJUSTMENT_US}
                                </span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.monthlyTotals
                                            .NetReserveAdjustmentAmount,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>{reserves.MONTHLY_TOTALS_TRANSFER}</span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.monthlyTotals
                                            .NetReserveTransferAmount,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>
                                    {reserves.MONTHLY_TOTALS_REPOSSESSION}
                                </span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.monthlyTotals
                                            .NetRepossessionAmount,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>{reserves.MONTHLY_TOTALS_CHARGEOFF}</span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.monthlyTotals
                                            .NetChargeOffAmount,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>
                                    {isSiteCanadian()
                                        ? reserves.MONTHLY_TOTALS_PAYOFF_CA
                                        : reserves.MONTHLY_TOTALS_PAYOFF_US}
                                </span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.monthlyTotals.NetPayoffAmount,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>
                                    {reserves.MONTHLY_TOTALS_OUTSTANDING}
                                </span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.monthlyTotals
                                            .TotalOutStandingBalance,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>{reserves.MONTHLY_TOTALS_RETENTION}</span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.monthlyTotals
                                            .MinimumRetentionAmount,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>
                                    {reserves.MONTHLY_TOTALS_DISBURSEMENT}
                                </span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.monthlyTotals
                                            .AmountAvailableForDisbursement,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>
                                    {reserves.MONTHLY_TOTALS_DISBURSEMENTAMT}
                                </span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.monthlyTotals
                                            .NetDisbursementAmount,
                                    )}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='list-column'>
                    <p className='table-title-strong'>
                        {reserves.MONTHLY_YEARLY_HEADER}
                        {` ${reserves.MONTHLY_FOR} `}
                        {date}
                    </p>
                    <div className='table-list'>
                        <div className='table-list-row table-list-header'>
                            <div className='table-list-label'>
                                <span>
                                    {reserves.MONTHLY_YEARLY_DESCRIPTION}
                                </span>
                            </div>
                            <div className='table-list-value'>
                                <span>{reserves.MONTHLY_YEARLY_CREDITS}</span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>{reserves.MONTHLY_YEARLY_EARNINGS}</span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.yearToDate
                                            .dealerEarningsUpFrontAmount,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>
                                    {reserves.MONTHLY_YEARLY_CHARGEBACK}
                                </span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.yearToDate
                                            .netReserveChargeBackAmount,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>
                                    {reserves.MONTHLY_YEARLY_ADJUSTMENT}
                                </span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.yearToDate
                                            .netReserveAdjustmentAmount,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>{reserves.MONTHLY_YEARLY_TRANSFER}</span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.yearToDate
                                            .netReserveTransferAmount,
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className='table-list-row'>
                            <div className='table-list-label'>
                                <span>
                                    {reserves.MONTHLY_YEARLY_DISBURSMENTS}
                                </span>
                            </div>
                            <div className='table-list-value'>
                                <span>
                                    {formatMoney(
                                        content.yearToDate
                                            .netDisbursementAmount,
                                    )}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p className='resume-note'>
                <span className='bold'>{reserves.MONTHLY_YEARLY_NOTE}</span>{' '}
                {reserves.MONTHLY_YEARLY_MESSAGE}
            </p>
        </>
    );
};

export default Resume;
